<template>
    <Main>
        <TableBox :config="config" :reload="isReload" :data-list.sync="dataList" @updateModel="updateModel($event)">
            <template #row="{ row, index, page, perPage }">
                <tr class="row-member">
                    <td :data-title="$t('exportRecord.no')">
                        <div class="col-first">
                            {{ index + 1 + (page - 1) * perPage }}
                        </div>
                    </td>
                    <td class="text-left col-created" :data-title="$t('exportRecord.timeDownload')">
                        <FormatDate :date="row.created_at" :is-kintone="true" format="YYYY/MM/DD HH:mm:ss"></FormatDate>
                    </td>
                    <td class="col-surname" :data-title="$t('exportRecord.linkName')">{{ row.dataLink?.link_name ?? '' }}</td>
                    <td class="col-name" :data-title="$t('exportRecord.status')">{{ checkStatus(row) }}</td>
                    <td class="col-name" :data-title="$t('exportRecord.typeFile')">
                        {{ row.extension }}
                    </td>
                    <td :data-title="''" class="col-action">
                        <div class="group-buttons justify-content-center">
                            <Button classes="btn-xs px-2 mr-2" type="info" v-if="row.status === 2" @click="handleGoExport(row)">
                                <el-icon class="el-icon-edit"></el-icon>
                                {{ $t('button.export') }}
                            </Button>
                            <Button classes="btn-xs px-2" v-loading="isLoadingDelete" @click="handleDeleteConfirm(row)" type="danger">
                                <el-icon class="el-icon-delete"></el-icon>
                                {{ $t('button.delete') }}</Button
                            >
                        </div>
                    </td>
                </tr>
            </template>
        </TableBox>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import TableBox from '@/components/partials/layout/TableBox';
import FormatDate from '@/components/partials/FormatDate';
import Button from '@/components/partials/Button';
import { checkStatusExport } from '@/utils';
export default {
    name: 'ExportList',
    components: {
        FormatDate,
        TableBox,
        Main,
        Button
    },
    data: function () {
        return {
            config: {
                q: '',
                action: 'exportDataShare/list',
                headers: [
                    {
                        label: 'exportRecord.no'
                    },
                    {
                        sort: 'created_at',
                        label: 'exportRecord.timeDownload'
                    },
                    {
                        sort: 'link_name',
                        label: 'exportRecord.linkName'
                    },
                    {
                        sort: 'status',
                        label: 'exportRecord.status'
                    },
                    {
                        label: 'exportRecord.typeFile'
                    },
                    {
                        label: ''
                    }
                ],
                dataFilter: {
                    data_link_id: ''
                },
                sort: {
                    selected: 'created_at',
                    order: 'desc'
                }
            },
            isReload: false,
            keySearch: null,
            dataList: [],
            isLoadingDelete: false
        };
    },
    methods: {
        updateModel(e) {
            this.config.dataFilter = Object.assign({}, e.dataFilter);
            this.config.q = e.search;
            this.keySearch = e.search;
        },
        checkStatus(row) {
            return checkStatusExport(row);
        },
        handleGoExport(row) {
            let url = row.path;
            let link = document.createElement('a');
            link.setAttribute('href', url); // Links to CSV File
            link.click();
        },
        handleDeleteConfirm(row) {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('exportRecord.msgDelete'),
                callback: () => {
                    this.deleteCallback(row);
                }
            });
        },
        deleteCallback(row) {
            this.isLoadingDelete = true;
            let successCallback = (response) => {
                this.isLoadingDelete = false;
                if (response.status === 200) {
                    this.isReload = !this.isReload;
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('exportRecord.msgDeleteSuccess')
                    });
                }
            };
            let errorCallback = () => {
                this.isLoadingDelete = false;
                this.isReload = !this.isReload;
            };
            let payload = {
                successCallback,
                errorCallback,
                id: row.id
            };
            this.$store.dispatch('exportDataShare/delete', payload);
        }
    }
};
</script>
